import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { ChangeEvent, FC } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { Checkbox, FormControlLabel } from 'ui'

import styles from './InputCheckbox.module.scss'

interface IInputCheckbox {
  data: orderApiSpace.ProductParamData
  productId: number
}

export const InputCheckbox: FC<IInputCheckbox> = ({ data, productId }) => {
  const { setParamOrder } = useActions()

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    setParamOrder({
      id: data.id,
      name: data.name,
      iconUrl: data.iconUrl,
      type: data.typeCode,
      productId: productId,
      value: e.target.checked as boolean,
    })
  }
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const params = useAppSelector(
    state => state.orderForm.forms[currentEditForm].params,
  )
  const param = params.find(item => item.id === data.id)

  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            name={`${data.id}_${data.name}`}
            checked={(param?.value as boolean) || false}
            onChange={handleCheckboxChange}
            className={styles.checkbox}
          />
        }
        label={data.name}
      />
    </div>
  )
}
